import React from 'react';

import { useWaypointTemplateCountsQuery } from '@dashboard/generated/wp/platform';
import { Skeleton } from '@mui/material';

import { NumberFormatter } from '@waypoint/react-formatters';

type Props = {
  id: string;
};

export default function TemplateSendsCount({ id }: Props) {
  const { data } = useWaypointTemplateCountsQuery({ variables: { id } });
  const count = data?.WaypointTemplate?.eventsCount;
  if (count === undefined) {
    return <Skeleton sx={{ height: 16, display: 'inline-block' }} width={20} />;
  }
  if (count === 1) {
    return <>1 send</>;
  }
  return (
    <>
      <NumberFormatter value={count} /> sends
    </>
  );
}
